'use client';

import HeaderLogo from '@/components/sections/builder/elements/header/header/header-logo';
import {
  HeaderElementDataType,
  HeaderMenuElementDataType,
  LayoutClassesType,
} from '@/components/sections/builder/elements/header/header/type';
import { UserNavMobile } from '@/components/sections/builder/elements/header/header/user-nav-mobile';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { cn } from '@/lib/utils';
import { Menu } from 'lucide-react';
import Link from 'next/link';
import React from 'react';

type NavigationMenuMobile = {
  layoutClasses: LayoutClassesType;
  dataMenus: HeaderMenuElementDataType[];
  data: HeaderElementDataType;
  themeId?: string;
  token?: string;
  tokenPreview?: string;
  preview?: boolean;
  setCollapsedAction: React.Dispatch<React.SetStateAction<boolean>>;
  createUrlAction: (
    url_path: string,
    opts?: {
      themeId?: string;
      token?: string;
      preview?: boolean;
    }
  ) => string;
};

export function NavigationMenuMobile({
  layoutClasses,
  dataMenus,
  data,
  themeId,
  token,
  tokenPreview,
  preview,
  setCollapsedAction,
  createUrlAction: createUrl,
}: NavigationMenuMobile) {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className={layoutClasses.mobileNav}>
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger asChild>
          <Button variant='ghost' size='sm'>
            <Menu className='h-5 w-5' />
            <span className='sr-only'>Toggle menu</span>
          </Button>
        </SheetTrigger>
        <SheetContent side='left' className='w-full max-w-full overflow-auto px-2'>
          <HeaderLogo {...data} />
          <Accordion type='single' collapsible className='mt-5 w-full'>
            {dataMenus.map((item, index) => (
              <AccordionItem value={`item-${index}`} key={index}>
                <AccordionTrigger
                  className={cn(
                    ' text-base font-semibold',
                    item.subMenuType === 'NONE' && '[&>svg]:opacity-0'
                  )}
                >
                  {item.subMenuType === 'NONE' ? (
                    <Link
                      href={createUrl(item.link || '', {
                        themeId,
                        token: tokenPreview as string,
                        preview,
                      })}
                      onClick={() => setIsOpen(false)}
                      className='text-base text-gray-700'
                    >
                      {item.label}
                    </Link>
                  ) : (
                    item.label
                  )}
                </AccordionTrigger>
                <AccordionContent>
                  <ul className='text-md py-2 text-gray-700'>
                    {item.subMenus?.map((subItem, subIndex) => (
                      <li key={subIndex} className='py-2 pl-10'>
                        <Link
                          href={createUrl(subItem.link || '', {
                            themeId,
                            token: tokenPreview as string,
                            preview,
                          })}
                          data-testid={`mobile-menu-${subItem.label}`}
                          onClick={() => setIsOpen(false)}
                          className='menu-item-with-hover-border'
                        >
                          <span className=''>{subItem.label}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <UserNavMobile token={token} onClose={() => setCollapsedAction(false)} />
        </SheetContent>
      </Sheet>
    </div>
  );
}
